import { Component, OnInit } from '@angular/core';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { ActivatedRoute } from '@angular/router';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-chat-support',
  templateUrl: './chat-support.component.html',
  styleUrls: ['./chat-support.component.css']
})
export class ChatSupportComponent implements OnInit {
  ticketId
  ticketData
  commentsArray = []
  comment
  loading = false
  arr = [1, 2, 3, 4, 5]
  currentUser
  loadMoreArr = []
  showButton = true
  totalItems
  loadingSupport = false
  constructor(private route: ActivatedRoute, private authService: AuthservicesService) { }

  ngOnInit(): void {

    this.route.params.subscribe(params => {
      this.ticketId = params["id"];
    });

    this.currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'))

    this.getSupportId()
    this.getComment(0)
  }


  getErrorImage(event) {
    this.authService.geterrorImage(event);
  }




  getSupportId() {
    this.authService.getSupportId(this.ticketId).subscribe((res: any) => {
      this.loadingSupport = true
      this.ticketData = res.data

    },
      error => {
        console.log(error)
      })
  }


  getComment(skip) {
    this.authService.getComment(this.ticketId, skip, environment.pageSize).subscribe((res: any) => {
      this.loading = true
      this.commentsArray = this.createArray(res.items)
      this.commentsArray.reverse()
      this.totalItems = res.total
      this.concatArray(this.commentsArray, this.totalItems)
    },
      error => {
        console.log(error)
      })
  }


  changeStatus(status) {
    this.authService.changeStatus(this.ticketId, status).subscribe((res: any) => {
      console.log(res)
      this.ticketData['status'] = res.data['status']
    },
      error => {
        console.log(error)
      })
  }





  onSubmit() {
    this.authService.addComment(this.comment, this.ticketId).subscribe((res: any) => {
      let obj = {
        id: res.data._id,
        name: this.currentUser.name,
        createdAt: res.data.CreatedAt,
        description: res.data.description,
        photo: this.currentUser.photo
      }
      this.loadMoreArr = this.loadMoreArr.concat(obj)
      this.comment = ""

      // this.commentsArray.push(obj)

    },

      error => {
        console.log(error)
      })
  }



  getDate(date) {
    return moment(date).fromNow()
  }



  createArray(arr) {
    let data = []
    arr.forEach(props => {
      data.push({
        id: props._id,
        name: props.postedBy.user.name,
        createdAt: props.createdAt,
        photo: props.postedBy.user.photo,
        description: props.description

      })
    });
    return data
  }

  concatArray(arr, total) {
    if (arr.length != 0) { this.loadMoreArr = this.loadMoreArr.concat(arr) }
    else if (arr.length == 0) {
      this.showButton = false
    }
    if (this.loadMoreArr.length == total && this.loadMoreArr.length != 0) this.showButton = false
  }


  showMore() {
    const skip = this.loadMoreArr.length
    this.getComment(skip)
  }

}
